export interface ICartPageProps {}

const CartPage: React.FunctionComponent<ICartPageProps> = (props) => {
  return (
    <>
      <p>This is the cart page.</p>
    </>
  );
};

export { CartPage };
